import React, { useEffect, useState } from "react";
import axios from "axios";
import styled from "styled-components";

// import { useDocumentModal } from "../../Components/DocumentModal/DocumentModalContext";
import { LitigationEventHeading } from "@/Components/DocumentModal/DocumentSideBar/LitigationDocumentMenu";

import { mediaRoute } from "../../Utils/helper";
import UploadDocModal from "../../Components/DocumentRow/UploadDocModal";
import TableLoader from "../Loaders/tableLoader";
import { getClientId, getCaseId } from "../../Utils/helper";
import api from "../../api/api";
import ButtonLoader from "../Loaders/ButtonLoader";
import DocumentUploadModal from "../Modals/documentUploadModal";
import { useDocumentModal } from "../common/CustomModal/CustomModalContext";

import {
  DetailedUploadCard,
  DetailedUploadCardNoLoader,
  DetailedViewCard,
} from "./DetailedViewCards";
import { DefaultEmptyCard, DefaultViewCard, DefaultViewCard2 } from "./defaultViewCard";
import { UpdatedUploadCard, UpdatedUploadCardNoLoader, UpdatedViewCard } from "./UpdatedViewCards";

const NameContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  color: white;
  font-weight: 600;
  font-size: 14px;
  background-color: var(--primary-80);
  height: 25px;
  position: relative;

  // Add trapezium shapes to the left and right
  &::before {
    content: "";
    position: absolute;
    top: 0;
    height: 0;
    width: 0;
    border-bottom: 0px solid var(--primary-80);
  }
  &::after {
    content: "";
    position: absolute;
    top: 0;
    height: 0;
    width: 0;
    border-bottom: 25px solid var(--primary-80);
  }
  &::before {
    left: -5px;
    border-left: 5px solid transparent;
  }
  &::after {
    right: -5px;
    border-right: 5px solid transparent;
  }
`;

const TabData = ({ activeTab, data, loading, all, refetchData, refetchLoading, pageView }) => {
  const { showDocumentModal } = useDocumentModal();
  const origin = process.env.REACT_APP_BACKEND_URL;
  const currentCase = getCaseId();
  const client = getClientId();
  const [showDocModal, setShowDocModal] = useState(false);
  const [selectedSlotId, setSelectedSlotId] = useState(null);
  const [selectedPanelId, setSelectedPanelId] = useState(null);
  const [selectedPageId, setSelectedPageId] = useState(null);
  // const [ispanlename, setispanlename] = useState(false);

  // State for handling modal and upload progress
  const [fileUploadModal, setFileUploadModal] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadFile, setUploadFile] = useState("");
  const [isAttachedDocs, setIsAttachedDocs] = useState({});
  const [isAttachedDocs2, setIsAttachedDocs2] = useState({});
  useEffect(() => {
    data?.slots?.map((slot) => {
      // const attachedDocs =
      //   all === true
      //     ? data?.page_docs?.filter(
      //         (doc) => doc?.document_slot?.id === slot?.id && doc?.document_slot?.slot_number !== 0
      //       )
      //     : data?.data?.filter(
      //         (doc) => doc?.document_slot?.id === slot?.id && doc?.document_slot?.slot_number !== 0
      //       );
      const attachedDocs = slot?.docs?.filter(
        (doc) => doc?.document_slot?.id === slot?.id && doc?.document_slot?.slot_number !== 0
      );
      if (attachedDocs?.length > 0) setIsAttachedDocs({ [data?.page?.name]: true });
    });

    getPanelsArray().map((panel) => {
      data?.slots?.map((slot) => {
        // const attachedDocs =
        //   all === true
        //     ? panel?.documents?.filter((doc) => doc?.document_slot?.id === slot?.id)
        //     : panel?.documents?.filter((doc) => doc?.document_slot?.id === slot?.id);
        const attachedDocs = panel?.docs?.filter((doc) => doc?.document_slot?.id === slot?.id);
        if (attachedDocs?.length > 0) setIsAttachedDocs2({ [data?.page?.name]: true });
      });
    });
  }, [data]);
  const handleUploadPopup = (slotId, itemId, pageId) => {
    setSelectedSlotId(slotId);
    setSelectedPageId(pageId);
    setShowDocModal(true); // Show the Doc modal
  };
  const handleUploadPopupwithoutSlots = (pageId) => {
    setSelectedPageId(pageId);
    setShowDocModal(true); // Show the Doc modal
  };
  const handleUploadPopupwithpanles = (slotId, panelId, pageId) => {
    setSelectedSlotId(slotId);
    setSelectedPanelId(panelId);
    setSelectedPageId(pageId);
    setShowDocModal(true);
  };
  const handleDocPreview = (doc) => {
    axios
      .get(`${origin}/api/attorney-staff/${doc.attached_by?.id}/profile-image/`)
      .then((response) => {
        doc.attached_by.profile_pic_29p = mediaRoute(response.data.profile_image);
      })
      .catch((error) => {
        console.error(`Error fetching profile image: ${error}`);
      });
    if (activeTab === "unsorted") {
      showDocumentModal("document", doc.upload, doc);
    } else {
      showDocumentModal("document", doc.upload, doc);
    }
  };

  const handleClose = () => {
    setShowDocModal(false); // Hide the Doc modal
    setSelectedSlotId(null);
    setSelectedPanelId(null);
    setSelectedPageId(null);
  };

  const addDocumentHandler = () => {
    setShowDocModal(false); // Hide the Doc modal
    setSelectedSlotId(null);
    setSelectedPanelId(null);
    setSelectedPageId(null);
  };

  const [isDragging, setIsDragging] = useState(false);
  const isDragginguploadingbutton = false;
  // const [isDragginguploadingbutton, setIsDragginguploadingbutton] = useState(false);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [draggedSlotNumber, setDraggedSlotNumber] = useState("");
  const [uploadingSlot, setUploadingSlot] = useState({
    slotId: null,
    panelId: null,
  });
  // Drag and Drop functionality
  const simulateProgress = (setUploadProgress) => {
    let progress = 0;

    const intervalId = setInterval(() => {
      progress += 10;
      setUploadProgress(progress);

      // Stop once we reach 100%
      if (progress >= 100) {
        clearInterval(intervalId);
      }
    }, 300); // 300ms delay between increments
  };
  const handleDrop = async (e, slot_id, pageId) => {
    e.preventDefault();
    setFileUploadModal(true);
    simulateProgress(setUploadProgress); // Simulate gradual progress
    setDraggedSlotNumber(slot_id);
    const files = e.dataTransfer.files;
    const fileSizeInMB = files[0].size / (1024 * 1024);
    setUploadFile(files[0]);
    const formData = new FormData();
    formData.append("file", files[0]);
    const response = await api.post(`/api/upload_doc/${getClientId()}/${getCaseId()}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    const docId = response?.data?.docId;

    try {
      await api.post("api/doc/attach/", {
        slot: slot_id,
        page_id: pageId,
        case_id: getCaseId(),
        panels: false,
        doc_id: docId,
        file_size: fileSizeInMB,
      });
      await refetchData();
    } catch (error) {
      console.error(error);
    } finally {
      setIsDragging(false);
      setFileUploadModal(false);
    }
  };
  const [uploadbuttonLoadingid, setuploadbuttonLoadingid] = useState(null);
  const handleDropwithpanles = async (e, slot_id, pageId, panel_id) => {
    e.preventDefault();
    setFileUploadModal(true);
    simulateProgress(setUploadProgress); // Simulate gradual progress

    setUploadingSlot({ slotId: slot_id, panelId: panel_id });
    const files = e.dataTransfer.files;
    const fileSizeInMB = files[0].size / (1024 * 1024);
    setUploadFile(files[0]);
    const formData = new FormData();
    formData.append("file", files[0]);

    try {
      const response = await api.post(
        `/api/upload_doc/${getClientId()}/${getCaseId()}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const docId = response?.data?.docId;
      await api.post("api/doc/attach/", {
        panel_id: panel_id,
        slot: slot_id,
        page_id: pageId,
        case_id: getCaseId(),
        panels: true,
        doc_id: docId,
        file_size: fileSizeInMB,
      });
      await refetchData();
    } catch (error) {
      console.error(error);
    } finally {
      setIsDragging(false);
      setFileUploadModal(false);
    }
  };
  const handleDropwithOutpanlesWithoutslots = async (e, panel, pageId, panelId) => {
    e.preventDefault();
    if (panel) {
      setFileUploadModal(true);
      simulateProgress(setUploadProgress); // Simulate gradual progress
      setuploadbuttonLoadingid(panelId);

      const files = e.dataTransfer.files;
      const fileSizeInMB = files[0].size / (1024 * 1024);
      setUploadFile(files[0]);
      const formData = new FormData();
      formData.append("file", files[0]);

      try {
        const response = await api.post(
          `/api/upload_doc/${getClientId()}/${getCaseId()}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        const docId = response?.data?.docId;
        await api.post("api/doc/attach/", {
          page_id: pageId,
          case_id: getCaseId(),
          doc_id: docId,
          file_size: fileSizeInMB,
        });
        await refetchData();
      } catch (error) {
        console.error(error);
      } finally {
        setFileUploadModal(false);
        setuploadbuttonLoadingid(null);
      }
    } else {
      setFileUploadModal(true);
      const files = e.dataTransfer.files;
      const fileSizeInMB = files[0].size / (1024 * 1024);
      const formData = new FormData();
      simulateProgress(setUploadProgress);
      formData.append("file", files[0]);

      try {
        const response = await api.post(
          `/api/upload_doc/${getClientId()}/${getCaseId()}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        const docId = response?.data?.docId;
        await api.post("api/doc/attach/", {
          page_id: pageId,
          case_id: getCaseId(),
          doc_id: docId,
          file_size: fileSizeInMB,
        });
        await refetchData();
      } catch (error) {
        console.error("Failed to handle drop:", error);
      } finally {
        setFileUploadModal(false);
      }
    }
  };
  function getPanelName(panel) {
    if (!panel || !data || !data.page) {
      return " ";
    }
    return panel.panel_name || "";
  }
  const getPanelsArray = () => {
    if (!data?.slots || data?.slots.length === 0) {
      return data?.panels && data.panels.length > 0 ? [data.panels] : [];
    } else {
      return data?.panels || [];
    }
  };
  const isSlotUploading = (slotId, panelId) => {
    return uploadingSlot?.slotId === slotId && uploadingSlot?.panelId === panelId; // Added parentheses for clarity
  };
  if (loading) {
    return <TableLoader />;
  }
  // const unAttachedDocuments = () => {
  //   return all
  //     ? data?.page_docs?.filter(
  //         (document) => document.document_slot === null || document.document_slot?.slot_number === 0
  //       )
  //     : data?.data?.filter(
  //         (document) => document.document_slot === null || document.document_slot?.slot_number === 0
  //       );
  // };

  const _unAttachedDocuments = () => {
    const unattached = [];
    const addedIds = new Set();

    if (!data) return [];

    const page = data;
    if (page.slots && Array.isArray(page.slots)) {
      page.slots?.forEach((slot) => {
        if (slot.docs && Array.isArray(slot.docs)) {
          slot.docs?.forEach((doc) => {
            if (
              (doc.document_slot === null || doc.document_slot?.slot_number === 0) &&
              !addedIds.has(doc.id)
            ) {
              unattached.push(doc);
              addedIds.add(doc.id);
            }
          });
        }
      });
    }

    if (page?.page?.panels && Array.isArray(page.panels)) {
      page.panels?.forEach((panel) => {
        if (panel.docs && Array.isArray(panel.docs)) {
          panel.docs.forEach((doc) => {
            if (
              (doc.document_slot === null || doc.document_slot?.slot_number === 0) &&
              !addedIds.has(doc.id)
            ) {
              unattached.push(doc);
              addedIds.add(doc.id);
            }
          });
        }
      });
    }

    return unattached;
  };

  const unsortedDocs = () => {
    const unattached = [];
    const addedIds = new Set();

    if (!data) return [];
    const page = data;

    page?.forEach((doc) => {
      if (
        (doc.document_slot === null || doc.document_slot?.slot_number === 0) &&
        !addedIds.has(doc.id)
      ) {
        unattached.push(doc);
        addedIds.add(doc.id);
      }
    });

    return unattached;
  };

  if (!data) {
    return <div className="loading-center">No Data</div>; // Centered loading indicator
  }
  if (activeTab !== "unsorted" && (!data?.panels || data?.panels.length === 0)) {
    return (
      <>
        {!all && (
          <div className="m-l-7 m-b-5 flex-nowrap align-items-center">
            <div className="panel-icon" style={{ marginRight: "5px", left: "0px" }}>
              <img
                src={data?.page?.page_icon}
                // height={19}
                // width={19}
                className="ic ic-25 d-flex align-items-center justify-content-center"
              />
            </div>
            <div
              className="panel-color"
              style={{
                background: "var(--primary)",
                left: "33px",
                display: "flex",
                alignItems: "center",
                fontWeight: "600",
                fontSize: "16px",
                fontFamily: "Inter",
                textTransform: "uppercase",
              }}
            >
              {/* <div
                style={{
                  height: 0,
                  width: "10px",
                  maxHeight: "max-content",
                  minHeight: "max-content",
                }}
              /> */}
              <h4
                className="d-flex align-items-center"
                style={{ color: "white", paddingLeft: "9px" }}
              >
                <small className="font-weight-600 anti-skew">{data?.page?.name}</small>
              </h4>
            </div>
          </div>
        )}
        <div>
          <div>
            {/* {data?.slots?.length === 0 && (
              <div className="d-flex">
                <div
                  className="panel-color"
                  style={{
                    background: "var(--primary)",
                    left: "27px",
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "600",
                    fontSize: "16px",
                    fontFamily: "Inter",
                    textTransform: "uppercase",
                  }}
                >
                  <div
                    style={{
                      height: 0,
                      width: "10px",
                      maxHeight: "max-content",
                      minHeight: "max-content",
                    }}
                  />
                  <h4 className="d-flex align-items-center  m-l-5" style={{ color: "white" }}>
                    <small className="font-weight-600 anti-skew">{data?.page?.name}</small>
                  </h4>
                </div>
              </div>
            )} */}
            <div
              className="row g-0 m-b-5 flex-row position-relative p-md-r-0 m-t-5"
              style={{
                gap: "5px",
              }}
            >
              <div className="col p-0 p-r-5">
                {/* <div className="height-25 m-b-5">
                  <h4
                    // style={{ backgroundColor: "var(--primary-15)" }}
                    className="bg-primary-5 text-capitalize d-flex align-items-center justify-content-center h-100 text-lg text-upper-case font-weight-semibold text-center client-contact-title"
                  >
                    {data?.page?.name || ""} Document Row
                  </h4>
                </div> */}
                {(isAttachedDocs[data?.page?.name] ||
                  isAttachedDocs2[data?.page?.name] ||
                  pageView === "default") && (
                  <div
                    className={`d-md-flex justify-content-start w-100 ${pageView === "default" && ""}`}
                  >
                    <div
                      className="icon-text-boxes d-flex flex-wrap w-100 e-template-row "
                      style={{
                        marginRight: pageView === "default" ? "0px" : 0,
                        height:
                          pageView === "detailed"
                            ? "347px"
                            : pageView === "default"
                              ? "auto"
                              : "auto",
                        ...(all && pageView === "detailed" && { marginBottom: "5px" }),
                      }}
                    >
                      {data?.slots?.map((slot) => {
                        // const attachedDocs =
                        //   all === true
                        //     ? data?.page_docs?.filter(
                        //         (doc) =>
                        //           doc?.document_slot?.id === slot?.id &&
                        //           doc?.document_slot?.slot_number !== 0
                        //       )
                        //     : data?.data?.filter(
                        //         (doc) =>
                        //           doc?.document_slot?.id === slot?.id &&
                        //           doc?.document_slot?.slot_number !== 0
                        //       );
                        const attachedDocs = slot?.docs?.filter(
                          (doc) =>
                            doc?.document_slot?.id === slot?.id &&
                            doc?.document_slot?.slot_number !== 0
                        );
                        return (
                          <React.Fragment key={slot.id}>
                            {attachedDocs?.length > 0
                              ? attachedDocs.map((doc) => (
                                  <DefaultViewCard
                                    key={doc.id}
                                    doc={doc}
                                    slot={slot}
                                    handleDocPreview={handleDocPreview}
                                  />
                                ))
                              : slot.slot_number !== 0 && (
                                  <DefaultEmptyCard
                                    slot={slot}
                                    page={data}
                                    item={null}
                                    isDragging={isDragging}
                                    refetchLoading={refetchLoading}
                                    handleDrop={handleDrop}
                                    handleUploadPopup={handleUploadPopup}
                                    isSlotUploading={isSlotUploading}
                                  />
                                )}
                          </React.Fragment>
                        );
                      })}
                      <UploadDocModal
                        show={showDocModal}
                        handleClose={handleClose}
                        slot_id={selectedSlotId}
                        page_id={selectedPageId}
                        caseId={currentCase}
                        clientId={client?.id}
                        isDocumentTab={true}
                        handleDocumentUpload={addDocumentHandler}
                        refetchLoading={refetchLoading}
                        refetchData={refetchData}
                      />
                    </div>
                  </div>
                )}
              </div>
              {data?.slots?.length === 0 ? (
                pageView === "default" ? (
                  <>
                    {/* <DefaultUploadCard
                  page={data}
                  item={{ id: 0 }}
                  isDragginguploadingbutton={isDragginguploadingbutton}
                  uploadbuttonLoadingid={0}
                  handleDropwithOutpanlesWithoutslots={handleDropwithOutpanlesWithoutslots}
                  handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
                  />  */}
                  </>
                ) : pageView === "detailed" ? (
                  <DetailedUploadCard
                    page={data}
                    item={{ id: 0 }}
                    isDragginguploadingbutton={isDragginguploadingbutton}
                    uploadbuttonLoadingid={0}
                    handleDropwithOutpanlesWithoutslots={handleDropwithOutpanlesWithoutslots}
                    handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
                  />
                ) : (
                  <UpdatedUploadCard
                    page={data}
                    item={{ id: 0 }}
                    isDragginguploadingbutton={isDragginguploadingbutton}
                    uploadbuttonLoadingid={0}
                    handleDropwithOutpanlesWithoutslots={handleDropwithOutpanlesWithoutslots}
                    handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
                  />
                )
              ) : pageView === "default" ? (
                <>
                  {/* <DefaultUploadCard
                  page={data}
                  item={{ id: 0 }}
                  isDragginguploadingbutton={isDragginguploadingbutton}
                  uploadbuttonLoadingid={0}
                  handleDropwithOutpanlesWithoutslots={handleDropwithOutpanlesWithoutslots}
                  handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
                  /> */}
                </>
              ) : pageView === "detailed" ? (
                <DetailedUploadCard
                  page={data}
                  item={{ id: 0 }}
                  isDragginguploadingbutton={isDragginguploadingbutton}
                  uploadbuttonLoadingid={0}
                  handleDropwithOutpanlesWithoutslots={handleDropwithOutpanlesWithoutslots}
                  handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
                />
              ) : (
                <UpdatedUploadCard
                  page={data}
                  item={{ id: 0 }}
                  isDragginguploadingbutton={isDragginguploadingbutton}
                  uploadbuttonLoadingid={0}
                  handleDropwithOutpanlesWithoutslots={handleDropwithOutpanlesWithoutslots}
                  handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
                />
              )}
            </div>
            {/* {unAttachedDocuments()?.length > 0 && (
              <>
                {pageView === "default" && (
                  <div className="m-l-7 m-b-5 flex-nowrap align-items-center">
                    <div
                      className="panel-color"
                      style={{
                        background: "var(--primary)",
                        left: "25px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          height: 0,
                          width: "10px",
                          maxHeight: "max-content",
                          minHeight: "max-content",
                        }}
                      />
                      <h4 className="d-flex align-items-center  m-l-5" style={{ color: "white" }}>
                        <small className="font-weight-600 anti-skew">Unattached Documents</small>
                      </h4>
                    </div>
                  </div>
                )}
                <div
                  // className="w-100 m-t-5 unattached-documents-container"
                  className={`w-100 unattached-documents-container ${(!all || pageView === "default") && " m-t-5"}`}
                  style={{
                    marginRight: "5px",
                    justifyContent: "end",
                    paddingRight: 0,
                    height: "auto",
                    ...(pageView !== "default" && {
                      display: "flex",
                      justifyContent: "flex-start",
                      flexWrap: "wrap",
                    }),
                  }}
                >
                  {unAttachedDocuments()?.map((document) => (
                    <DefaultViewCard2
                      key={document.id}
                      doc={document}
                      slot={undefined}
                      handleDocPreview={handleDocPreview}
                    />
                  ))}
                </div>
              </>
            )} */}
          </div>
        </div>
        <DocumentUploadModal
          uploadFile={uploadFile}
          uploadProgress={uploadProgress}
          show={fileUploadModal}
          onHide={() => setFileUploadModal(false)}
        />
      </>
    );
  }
  return (
    <>
      {activeTab === "unsorted" && (
        <div className="m-l-7 m-b-5 flex-nowrap align-items-center">
          <div className="panel-icon" style={{ marginRight: "5px", left: "0px" }}>
            <i className="ic ic-25 ic-file-colored d-flex align-items-center justify-content-center" />
          </div>
          <div
            className="panel-color"
            style={{
              background: "var(--primary)",
              left: "33px",
              display: "flex",
              alignItems: "center",
              fontWeight: "600",
              fontSize: "16px",
              fontFamily: "Inter",
              textTransform: "uppercase",
            }}
          >
            {/* <div
              style={{
                height: 0,
                width: "10px",
                maxHeight: "max-content",
                minHeight: "max-content",
              }}
            /> */}
            <h4
              className="d-flex align-items-center"
              style={{ color: "white", paddingLeft: "9px" }}
            >
              <small className="font-weight-600 anti-skew">Unsorted</small>
            </h4>
          </div>
        </div>
      )}
      {!all && activeTab !== "unsorted" && (
        <div className="m-l-7 m-b-5 flex-nowrap align-items-center">
          <div className="panel-icon" style={{ marginRight: "5px", left: "0px" }}>
            <img
              src={data?.page?.page_icon}
              // height={19}
              // width={19}
              className="ic ic-25 d-flex align-items-center justify-content-center"
            />
          </div>
          <div
            className="panel-color"
            style={{
              background: "var(--primary)",
              left: "33px",
              display: "flex",
              alignItems: "center",
              fontWeight: "600",
              fontSize: "16px",
              fontFamily: "Inter",
              textTransform: "uppercase",
            }}
          >
            {/* <div
              style={{
                height: 0,
                width: "10px",
                maxHeight: "max-content",
                minHeight: "max-content",
              }}
            /> */}
            <h4
              className="d-flex align-items-center  m-l-5"
              style={{ color: "white", paddingLeft: "9px" }}
            >
              <small className="font-weight-600 anti-skew">{data?.page?.name}</small>
            </h4>
          </div>
        </div>
      )}

      {getPanelsArray().map((panel, panelIndex) => (
        <div key={panel.id ?? panelIndex}>
          <div>
            <div className="border-box  has-checklist position-relative" style={{ zIndex: 1 }}>
              <div
                style={{
                  height: "25px",
                }}
                className={"title-bar-main-div d-flex flex-row has-title-bg-documents-rows"}
              >
                {/* {panelIconSrc && (
                      <div
                        style={{
                          position: "absolute",
                          left: "0px",
                          width: "19px",
                          height: "19px",
                          top: "1px",
                        }}
                      >
                        <span className="page-icon">
                          <img src={panelIconSrc} alt="Icon" style={{ height: "100%", width: "100%" }} />
                        </span>
                      </div>
                    )} */}

                <div
                  style={{ paddingLeft: "0px", marginRight: "5px", zIndex: "1" }}
                  className="top-header align-items-center d-flex  responsive-width-of-title "
                >
                  <NameContainer
                    style={{
                      paddingLeft: "8px",
                      minWidth: "245px",
                      fontWeight: "600",
                    }}
                  >
                    {data?.page?.id === 19 ? (
                      <LitigationEventHeading
                        panel={panel}
                        showNumber={false}
                        textColorClass="text-white"
                      />
                    ) : (
                      <div className="d-flex align-items-center height-21">
                        {data?.slots?.length === 0 || data?.slots === null
                          ? "Nothing Added"
                          : getPanelName(panel).trim() === ""
                            ? "No Name"
                            : getPanelName(panel)}
                      </div>
                    )}
                  </NameContainer>
                </div>
              </div>
            </div>
            {/* <div>
              <div className="d-flex align-items-center w-100 skewed-primary-gradient-custom p-5-x alpha  ">
                <div
                  className="col-auto p-0 text-white"
                  style={{
                    marginLeft: "34px",
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  {data?.slots?.length === 0 || data?.slots === null
                    ? "Nothing Added"
                    : getPanelName(panel).trim() === ""
                      ? "No Name"
                      : getPanelName(panel)}
                </div>
              </div>
            </div> */}
          </div>
          <div
            className="row g-0 flex-row position-relative m-b-5 p-md-r-0   m-t-5"
            style={{
              gap: "5px",
            }}
          >
            <div className="col p-0 p-r-5">
              {/* <div className="height-25 m-b-5">
                <h4
                  // style={{ backgroundColor: "var(--primary-15)" }}
                  className="bg-primary-5 text-capitalize d-flex align-items-center justify-content-center h-100 text-lg text-upper-case font-weight-semibold text-center client-contact-title"
                >
                  {getPanelName(panel) || ""} Document Row
                </h4>
              </div> */}
              {(isAttachedDocs[data?.page?.name] ||
                isAttachedDocs2[data?.page?.name] ||
                pageView === "default") && (
                <div className="d-md-flex justify-content-start w-100">
                  <div
                    className={`icon-text-boxes d-flex flex-wrap w-100 e-template-row ${pageView === "default" && ""}`}
                    style={{
                      marginRight: pageView === "default" ? "0px" : 0,
                      height: "auto",
                    }}
                  >
                    {data?.slots?.map((slot) => {
                      // const attachedDocs =
                      //   all === true
                      //     ? panel?.documents?.filter((doc) => doc?.document_slot?.id === slot?.id)
                      //     : panel?.documents?.filter((doc) => doc?.document_slot?.id === slot?.id);
                      const attachedDocs = panel?.docs?.filter(
                        (doc) =>
                          doc?.document_slot?.id === slot?.id &&
                          doc?.document_slot?.slot_number !== 0
                      );
                      return (
                        <React.Fragment key={slot.id}>
                          {attachedDocs?.length > 0
                            ? attachedDocs.map((doc) => (
                                <DefaultViewCard
                                  key={doc.id}
                                  doc={doc}
                                  slot={slot}
                                  handleDocPreview={handleDocPreview}
                                />
                              ))
                            : slot.slot_number !== 0 && (
                                <DefaultEmptyCard
                                  slot={slot}
                                  page={data}
                                  item={panel}
                                  isDragging={isDragging}
                                  refetchLoading={refetchLoading}
                                  handleDrop={handleDropwithpanles}
                                  handleUploadPopup={handleUploadPopupwithpanles}
                                  isSlotUploading={isSlotUploading}
                                />
                              )}
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
            {data?.slots?.length === 0 || data?.slots === null ? (
              isDragginguploadingbutton && panel?.id === uploadbuttonLoadingid ? (
                <div
                  className="col-12 col-md-3 col-xl icon-text-box text-center order-last  btn-primary-lighter-2 font-weight-semibold btn-white-hover cursor-pointer"
                  style={{
                    width: "70px",
                    height: "55px",
                  }}
                >
                  <div className="d-flex align-items-center justify-content-center">
                    <ButtonLoader />
                    <span
                      style={{
                        marginLeft: "5px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Uploading...
                    </span>
                  </div>
                </div>
              ) : pageView === "default" ? (
                <>
                  {/* <DefaultUploadCardNoLoader
                  page={data}
                  item={panel}
                  handleDropwithOutpanlesWithoutslots={handleDropwithOutpanlesWithoutslots}
                  handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
                  /> */}
                </>
              ) : pageView === "detailed" ? (
                <DetailedUploadCardNoLoader
                  page={data}
                  item={panel}
                  handleDropwithOutpanlesWithoutslots={handleDropwithOutpanlesWithoutslots}
                  handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
                />
              ) : (
                <UpdatedUploadCardNoLoader
                  page={data}
                  item={panel}
                  handleDropwithOutpanlesWithoutslots={handleDropwithOutpanlesWithoutslots}
                  handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
                />
              )
            ) : isDragginguploadingbutton && panel?.id === uploadbuttonLoadingid ? (
              <div className="col-12 col-md-3 col-xl icon-text-box text-center order-last height-25 btn-primary-lighter-2 font-weight-semibold btn-white-hover cursor-pointer">
                <div className="d-flex align-items-center justify-content-center">
                  <ButtonLoader />
                  <span
                    style={{
                      marginLeft: "5px",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    Uploading...
                  </span>
                </div>
              </div>
            ) : pageView === "default" ? (
              <>
                {/* <DefaultUploadCardNoLoader
                  page={data}
                  item={panel}
                  handleDropwithOutpanlesWithoutslots={handleDropwithOutpanlesWithoutslots}
                  handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
                  /> */}
              </>
            ) : pageView === "detailed" ? (
              <DetailedUploadCardNoLoader
                page={data}
                item={panel}
                handleDropwithOutpanlesWithoutslots={handleDropwithOutpanlesWithoutslots}
                handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
              />
            ) : (
              <UpdatedUploadCardNoLoader
                page={data}
                item={panel}
                handleDropwithOutpanlesWithoutslots={handleDropwithOutpanlesWithoutslots}
                handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
              />
            )}
          </div>
        </div>
      ))}

      {(data?.panels === null || data?.panels?.length === 0) && data?.slots?.length > 0 ? (
        <>
          {/* <DefaultUploadCardWithoutPanelsWithoutSlots
          page={data}
          isDragginguploadingbutton={isDragginguploadingbutton}
          handleDropwithOutpanlesWithoutslots={handleDropwithOutpanlesWithoutslots}
          handleUploadPopupwithoutSlots={handleUploadPopupwithoutSlots}
          /> */}
        </>
      ) : (
        ""
      )}
      {/* </div> */}

      <UploadDocModal
        show={showDocModal}
        handleClose={handleClose}
        slot_id={selectedSlotId}
        page_id={selectedPageId}
        caseId={currentCase}
        clientId={client?.id}
        isDocumentTab={selectedPanelId ? false : true}
        handleDocumentUpload={addDocumentHandler}
        refetchLoading={refetchLoading}
        refetchData={refetchData}
        panel_id={selectedPanelId}
      />
      {/* {unAttachedDocuments()?.length > 0 && (
        <>
          {pageView === "default" && (
            <div className="m-l-7 m-b-5 flex-nowrap align-items-center">
              <div
                className="panel-color"
                style={{
                  background: "var(--primary)",
                  left: "25px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    height: 0,
                    width: "10px",
                    minHeight: "max-content",
                    maxHeight: "max-content",
                  }}
                />
                <h4 className="d-flex align-items-center  m-l-5" style={{ color: "white" }}>
                  <small className="font-weight-600 anti-skew">Unattached Documents</small>
                </h4>
              </div>
            </div>
          )}

          <div
            className="w-100 m-t-5 unattached-documents-container"
            style={{
              marginRight: "5px",
              justifyContent: "end",
              height: "auto",
              ...(pageView !== "default" && {
                display: "flex",
                justifyContent: "flex-start",
                flexWrap: "wrap",
              }),
            }}
          >
            {unAttachedDocuments()?.map((document) =>
              pageView === "default" ? (
                <DefaultViewCard2
                  key={document.id}
                  doc={document}
                  slot={undefined}
                  handleDocPreview={handleDocPreview}
                />
              ) : pageView === "detailed" ? (
                <DetailedViewCard
                  key={document.id}
                  doc={document}
                  slot={document?.document_slot}
                  handleDocPreview={handleDocPreview}
                  modifiedView={true}
                />
              ) : (
                <UpdatedViewCard
                  key={document.id}
                  doc={document}
                  slot={document?.document_slot}
                  handleDocPreview={handleDocPreview}
                  modifiedView={true}
                />
              )
            )}
          </div>
        </>
      )} */}
      {activeTab === "unsorted" && unsortedDocs()?.length > 0 && (
        <>
          <div
            className="w-100 m-t-5 unattached-documents-container"
            style={{
              marginRight: "5px",
              justifyContent: "end",
              height: "auto",
              ...(pageView !== "default" && {
                display: "flex",
                justifyContent: "flex-start",
                flexWrap: "wrap",
              }),
            }}
          >
            {unsortedDocs()?.map((document) =>
              pageView === "default" ? (
                <DefaultViewCard2
                  key={document.id}
                  doc={document}
                  slot={undefined}
                  handleDocPreview={handleDocPreview}
                />
              ) : pageView === "detailed" ? (
                <DetailedViewCard
                  key={document.id}
                  doc={document}
                  slot={document?.document_slot}
                  handleDocPreview={handleDocPreview}
                  modifiedView={true}
                />
              ) : (
                <UpdatedViewCard
                  key={document.id}
                  doc={document}
                  slot={document?.document_slot}
                  handleDocPreview={handleDocPreview}
                  modifiedView={true}
                />
              )
            )}
          </div>
        </>
      )}
      <DocumentUploadModal
        uploadFile={uploadFile}
        uploadProgress={uploadProgress}
        show={fileUploadModal}
        onHide={() => setFileUploadModal(false)}
      />
    </>
  );
};

export default TabData;
